@let current = selected();
<div class="person-select" [class.person-select--open]="open()" [class.person-select--disabled]="disabled()">
  @if (label()) {
    <span class="person-select__label">
      {{ label() }}
      @if (required()) {
        <span class="person-select__label-asterisk" aria-hidden="true">*</span>
      }
    </span>
  }
  <button
    #triggerBtn
    cdkOverlayOrigin
    #triggerOrigin="cdkOverlayOrigin"
    type="button"
    class="person-select__trigger"
    [attr.aria-haspopup]="'listbox'"
    [attr.aria-expanded]="open()"
    [attr.aria-required]="required() ? 'true' : null"
    [attr.aria-label]="label() || null"
    [disabled]="disabled()"
    (click)="toggle()"
  >
    @if (current) {
      <app-avatar [name]="current.displayName" [size]="26" />
      <span class="person-select__value">{{ current.displayName }}</span>
    } @else {
      <span class="person-select__placeholder">
        {{ placeholderKey() | translate }}
      </span>
    }
    <span class="person-select__spacer"></span>
    <mat-icon class="person-select__chevron" aria-hidden="true">expand_more</mat-icon>
  </button>

  <ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOrigin]="triggerOrigin"
    [cdkConnectedOverlayOpen]="open()"
    [cdkConnectedOverlayHasBackdrop]="true"
    cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
    [cdkConnectedOverlayPanelClass]="'person-select__overlay-panel'"
    [cdkConnectedOverlayPositions]="[
      { originX: 'start', originY: 'bottom', overlayX: 'start', overlayY: 'top', offsetY: 6 },
      { originX: 'start', originY: 'top', overlayX: 'start', overlayY: 'bottom', offsetY: -6 },
    ]"
    [cdkConnectedOverlayWidth]="triggerOrigin.elementRef.nativeElement.offsetWidth"
    (backdropClick)="close(false)"
    (detach)="close(false)"
  >
    <div class="person-select__pop">
      <div class="person-select__search">
        <mat-icon aria-hidden="true">search</mat-icon>
        <input
          #searchInput
          type="text"
          class="person-select__search-input"
          role="combobox"
          aria-autocomplete="list"
          [attr.aria-expanded]="open()"
          [attr.aria-controls]="'ps-listbox'"
          [attr.aria-activedescendant]="activeId()"
          [attr.aria-label]="searchPlaceholderKey() | translate"
          [placeholder]="searchPlaceholderKey() | translate"
          [value]="query()"
          (input)="onSearchInput($event)"
          (keydown)="onSearchKeydown($event)"
        />
      </div>
      <ul id="ps-listbox" class="person-select__list" role="listbox">
        @for (item of keyboardItems(); track item.id + (item.isNone ? '-none' : '')) {
          <li>
            <button
              type="button"
              [id]="optionDomId(item)"
              class="person-select__option"
              [class.person-select__option--none]="item.isNone"
              [class.person-select__option--selected]="isSelected(item)"
              [class.person-select__option--active]="isActive(item)"
              role="option"
              [attr.aria-selected]="isSelected(item)"
              (click)="selectByItem(item)"
              tabindex="-1"
            >
              @if (item.isNone) {
                <span class="person-select__none-badge" aria-hidden="true">—</span>
                <span class="person-select__option-name">{{ noneKey() | translate }}</span>
              } @else {
                <app-avatar [name]="item.displayName" [size]="26" />
                <span class="person-select__option-name">{{ item.displayName }}</span>
                @if (isSelected(item)) {
                  <mat-icon class="person-select__option-check" aria-hidden="true">check</mat-icon>
                }
              }
            </button>
          </li>
        }
        @if (keyboardItems().length === (allowNone() ? 1 : 0)) {
          <li class="person-select__empty">{{ emptyKey() | translate }}</li>
        }
      </ul>
    </div>
  </ng-template>
</div>
